import Cookie from 'js-cookie'

const Order = 'order';

export function getOrder(){
    return Cookie.get(Order);
}

export function setOrder(info){
    return Cookie.set(Order,info)
}

export function removeOrder(){
    return Cookie.remove(Order)
}

const CourseId = 'courseId';

export function getCourseId(){
    return Cookie.get(CourseId);
}

export function setCourseId(info){
    return Cookie.set(CourseId,info)
}

export function removeCourseId(){
    return Cookie.remove(CourseId)
}


// WEBPACK FOOTER //
// ./src/utils/order.js